export default __webpack_public_path__ + "static/Specialty-Pharmacy-Locator-Flashcard-ea3314a0b69b8c89c988ddd14a60f19c.pdf";